/**
 * function for displaying the notification chips
 */
function notificationChips() {
	const chipContainer = $( ".notification-dropdown-container .chip-container" );
		
	chipContainer.empty();
	$( ".notification-btn" ).css( 'color', 'transparent' ); // keep a space so button doesn't collapse

	// target only role checkboxes
	const checkboxes = $( ".notification-dropdown-container .notification-checkbox" );
	
	const selected = checkboxes.filter( ":checked" ).map( function() {
		return $( this ).data( 'chip' );
	} ).get();

	if( selected.length === checkboxes.length ) {
		chipContainer.append( `<div class="chip">All notifications</div>` );
	}
	
	else if ( selected.length === 0 ) {
		$( ".notification-btn" ).css( 'color', '#c2c2c2' );
	}
	
	else {
		selected.forEach( item => {
			const chip = $( `<div class="chip">${item}</div>`);
			
			chipContainer.append( chip );
		});
	}
}
